import axiosInstance from "@/lib/axiosInstance";
import { getApiErrorMessage } from "@/lib/apiError";
import type { PortalGymsResponseDO } from "@/types/auth";
import type { GymUiFlags } from "@/types/center";

export const gymsService = {
  async fetchMyGyms(): Promise<PortalGymsResponseDO> {
    try {
      const response = await axiosInstance.get<PortalGymsResponseDO>("/gyms/me");
      return response.data;
    } catch (error) {
      throw new Error(getApiErrorMessage(error, "Failed to fetch gyms"));
    }
  },

  async updateUiFlags(flags: Partial<GymUiFlags>): Promise<void> {
    try {
      await axiosInstance.patch("/gyms/ui-flags", flags);
    } catch (error) {
      throw new Error(getApiErrorMessage(error, "Failed to update UI flags"));
    }
  },
};
